import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

const PwaRefreshButton = () => {
    const [isPwa, setIsPwa] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);

    useEffect(() => {
        const checkPwaMode = () => {
            const standalone = window.matchMedia(
                "(display-mode: standalone)"
            ).matches;

            const iosStandalone =
                "standalone" in window.navigator &&
                (window.navigator as Navigator & {
                    standalone?: boolean;
                }).standalone;

            setIsPwa(standalone || !!iosStandalone);
        };

        checkPwaMode();
    }, []);

    const handleRefresh = () => {
        if (isRefreshing) return;

        setIsRefreshing(true);
        window.location.reload();
    };

    if (!isPwa) return null;

    return (
        <button
            type="button"
            onClick={handleRefresh}
            disabled={isRefreshing}
            aria-label="Refresh"
            title="Refresh"
            className="
                fixed
                bottom-20
                right-5
                z-[9999]
                flex
                h-12
                w-12
                items-center
                justify-center
                rounded-full
                bg-primary
                text-white
                shadow-lg
                shadow-primary/30
                ring-4
                ring-white/80
                transition-all
                duration-200
                hover:scale-110
                hover:shadow-xl
                active:scale-95
                disabled:cursor-not-allowed
                disabled:opacity-80
            "
        >
            <RefreshCw
                size={21}
                strokeWidth={2.5}
                className={isRefreshing ? "animate-spin" : ""}
            />
        </button>
    );
};

export default PwaRefreshButton;